module.exports = __webpack_public_path__ + "media/answer.02b924a1.mp3";